<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[summary$, adjustments$]"></ef-loading-container>
<ef-leave-adjustment-presenter
  [adjustments] = 'adjustments$ | async'
  [summary] = 'summary$ | async'
  [lagDays] = 'lagDays$ | async'
  [accrualPeriods] = 'accrualPeriods$ | async'
  (SaveAdjustment)="onSaveAdjustment($event)"
  (RecalcAdjustment)="onRecalcAdjustment($event)"
  (SaveSummary)="onSaveSummary($event)"
  (SaveLagDays)="onSaveLagDays($event)"
  (SaveAccrualPeriod)="onSaveAccrualPeriod($event)"
  (LoadAdjustments)="onLoadAdjustments($event)"
  [selectedError]="selectedErrorWithStatus$ | async"
  (ShowError)="onShowError($event)"
>
</ef-leave-adjustment-presenter>
